import Rest from '@/services/Rest';

/**
 * @typedef {WithdrawService}
 */
export default class NoteCenterIntegration extends Rest {
  /**
   * @type {String}
   */
  static resource = '/fiscal-center-integration/'
}
